import { portalHomeImages } from "@/components/PortalHome/portalHomeAssets";

const awansMilestones = [
  {
    threshold: 200,
    pointsLabelKey: "portalHome.bonusAwans.milestones.goal.pointsLabel",
    labelKey: "portalHome.bonusAwans.milestones.goal.label",
  },
  {
    threshold: 400,
    pointsLabelKey: "portalHome.bonusAwans.milestones.challenge.pointsLabel",
    labelKey: "portalHome.bonusAwans.milestones.challenge.label",
  },
];

/**
 * @typedef {Object} PortalBonusCampaignsApiMock
 * @property {{ balance: number, updatedAt: string, purchases: object[] }} account
 * @property {{ daysRemaining: number }} period
 * @property {Record<string, object>} programs
 */
export const portalBonusCampaignsApiMock = {
  account: {
    balance: 2731,
    updatedAt: "07.04.2026",
    purchases: [
      { icon: "car-side", minimumKey: "portalHome.purchases.carMinimum", count: 20 },
      {
        icon: "truck",
        minimumKey: "portalHome.purchases.busMinimum",
        count: 8,
        countFaded: true,
      },
      { icon: "motorcycle", minimumKey: "portalHome.purchases.bikeMinimum", count: 10 },
    ],
  },
  period: {
    daysRemaining: 118,
  },
  programs: {
    uhrd: {
      currentUnits: 14,
      goal: 25,
      pointsLabelKey: "portalHome.bonusUhrd.pointsLabel",
      levels: [
        { threshold: 0, active: true },
        { threshold: 25, active: false },
      ],
    },
    uhrdGoalAchieved: {
      currentUnits: 38,
      goal: 25,
      goalAchieved: true,
      pointsLabelKey: "portalHome.bonusUhrd.pointsLabel",
      beyondGoalPointsLabelKey: "portalHome.bonusUhrd.beyondGoalPointsLabel",
      beyondGoalTotalPointsLabelKey:
        "portalHome.bonusUhrd.beyondGoalTotalPointsLabel",
      levels: [
        { threshold: 0, active: true },
        { threshold: 25, active: true },
        { threshold: 160, active: false },
      ],
    },
    awans: {
      currentUnits: 96,
      goal: 200,
      maxUnits: 400,
      milestones: awansMilestones,
    },
    awansFirstMilestoneAchieved: {
      currentUnits: 256,
      goal: 200,
      maxUnits: 400,
      firstMilestoneAchieved: true,
      milestones: awansMilestones,
    },
    goals: {
      currentUnits: 48,
      goal: 200,
      maxUnits: 400,
      milestones: awansMilestones,
      remainingUnitsToGoal: 62,
    },
  },
};

const bonusPageHeroSrc = portalHomeImages.bonusCampaignHeroImage;

export const portalBonusCampaignPageMeta = {
  uhrd: {
    heroSrc: bonusPageHeroSrc,
    toolbarIconKey: "bonusUhrd",
  },
  awans: {
    heroSrc: bonusPageHeroSrc,
    toolbarIconKey: "bonusAwans",
  },
  goals: {
    heroSrc: bonusPageHeroSrc,
    toolbarIconKey: "bonusGoals",
  },
};

export function fetchPortalBonusCampaignsMock() {
  return Promise.resolve(portalBonusCampaignsApiMock);
}
